"use client";

import { PropsWithChildren, forwardRef } from "react";
import { Text, Wrapper } from "./skeleton.styles";

export interface SkeletonProps {
    /**
     * Width of the skeleton.
     */
    width?: string | number;

    /**
     * Height of the skeleton.
     */
    height?: string | number;

    /**
     * Border radius of the skeleton.
     */
    rounded?: "md" | "lg" | "full";

    /**
     * Theme of the skeleton.
     */
    theme?: "light" | "dark";

    /**
     * Class name of the skeleton.
     */
    className?: string;
}

export const Skeleton = forwardRef<HTMLDivElement, PropsWithChildren<SkeletonProps>>(
    ({ width, height, rounded, className, theme, children }, ref) => {
        return (
            <Wrapper
                rounded={rounded}
                className={className}
                display={theme}
                hasChildren={children ? true : false}
                style={{
                    width: width ? (typeof width === "string" ? width : `${width}px`) : undefined,
                    height: height ? (typeof height === "string" ? height : `${height}px`) : undefined,
                }}
                ref={ref}
            >
                <Text>{children}</Text>
            </Wrapper>
        );
    },
);

Skeleton.displayName = "Skeleton";
